import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section className="rapid_free_services p-100 ai_solution_process tekrevol_dark_bg">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              AI Solutions Development <span>Process at TekRevol</span>
            </h3>
            <p>
              We follow our flagship, agile-based process to develop, integrate,
              implement and deploy artificial intelligence solutions. Our
              process is simple, structured and guarantees development ROI
              because each step is productive and yields game-changing
              deliverables.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">01</div>
              <div className="rapid_content">
                <h5>Business Requirements</h5>
                <p>
                  We understand the unique challenges of your business – these
                  include the objectives and goals your business wants to
                  achieve, problems in your operational cycle and bottlenecks in
                  business management. Then we compare with industry standards,
                  existing AI solutions and create an AI software development
                  strategy with a complete roadmap for design and development
                  support.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">02</div>
              <div className="rapid_content">
                <h5>Data Collection</h5>
                <p>
                  We collect initial data to preprocess and train the
                  algorithms. We build strong data foundations, with an
                  infrastructure, processing systems, collection and submission
                  protocols and take necessary steps your AI solution will need
                  for data engineering. We further follow micro data cleaning
                  and organization steps like annotation and splitting to make
                  model training easier. Key deliverables of this stage include
                  current data gathering documentation and future data
                  collection APIs with plan.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">03</div>
              <div className="rapid_content">
                <h5>Model Development</h5>
                <p>
                  We utilize the technology stack with AI building frameworks to
                  develop AI-based advanced models that can accurately perform
                  the desired automated tasks based on the datasets utilized for
                  training. We perform key activities including model selection,
                  engineer features, tune hyper-parameters, and validate models.
                  The major deliverable of this step is the superb trained AI
                  models that either run on machine learning or its advanced
                  adaptations like computer vision.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">04</div>
              <div className="rapid_content">
                <h5>Testing and QA</h5>
                <p>
                  We rigorously test and evaluate the AI models to ensure they
                  meet the performance and accuracy standards set out in the AI
                  development strategy. We perform comprehensive error analysis,
                  refine models and set benchmarks for future testing and
                  maintenance. The deliverables of this stage are an error log
                  and a documented evaluation report.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">05</div>
              <div className="rapid_content">
                <h5>Deployment</h5>
                <p>
                  During the deployment stage, we implement the AI model into
                  the business production environment and integrate it with new
                  and existing systems and internal workflows. Deployment
                  typically starts with a strategy where we account for
                  infrastructure, scalability and security. We check the setup
                  environment, configure networks, allow editing and
                  manipulation access and also provide system training to end
                  users. At TekRevol, while delivering top-tier AI application
                  development services, we also create integration documents and
                  design user manuals.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">06</div>
              <div className="rapid_content">
                <h5>Maintenance</h5>
                <p>
                  In the maintenance stage, we ensure the continuous optimal
                  performance of your AI software through diligent monitoring
                  and regular updates. We track key performance indicators
                  (KPIs) and detect anomalies or performance degradations, and
                  take immediate corrective actions when necessary. Our team
                  conducts periodic model retraining with new data to maintain
                  accuracy and relevance. We have AI maintenance teams that
                  provide regular updates to ensure stability and efficiency.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
